// extracted by mini-css-extract-plugin
module.exports = {"details":"video-card-module--details--3nmUv","card":"video-card-module--card--tLGLz"};